import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import z from "zod";

const bookableOrderItemStatusValues = [
    "checked-in",
    "checked-out",
    "unchecked",
    "cancelled",
] as const;
const bookableOrderItemStatusValuesZodSchema = z.enum(
    bookableOrderItemStatusValues,
);
type BookableOrderItemStatusValue = z.infer<
    typeof bookableOrderItemStatusValuesZodSchema
>;

const bookableOrderItemStatusZodSchema = z.array(
    z.object({
        index: z.number().min(0),
        value: bookableOrderItemStatusValuesZodSchema,
    }),
);
type BookableOrderItemStatus = z.infer<typeof bookableOrderItemStatusZodSchema>;

const bookableOrderItemStatusTranslations: Record<
    BookableOrderItemStatusValue,
    Translatable
> = {
    "checked-in": translation({
        sv: "Incheckad",
        en: "Checked in",
    }),
    "checked-out": translation({
        sv: "Utcheckad",
        en: "Checked out",
    }),
    unchecked: translation({
        sv: "Oanvänd",
        en: "Unused",
    }),
    cancelled: translation({
        sv: "Avbokad",
        en: "Cancelled",
    }),
};

export {
    bookableOrderItemStatusTranslations,
    bookableOrderItemStatusValues,
    bookableOrderItemStatusValuesZodSchema,
    bookableOrderItemStatusZodSchema,
};
export type { BookableOrderItemStatus, BookableOrderItemStatusValue };
